import {
  // Box,
  // Button,
  // Grid,
  ListItemIcon,
  Menu,
  MenuItem,
  // Typography,
} from '@mui/material';
import Logout from '@mui/icons-material/Logout';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';
import {
  clearLocalStorage,
  getLogoutPath,
  // ChangePasswordFromDashboard,
} from '@/utils/common';
import { Suspense, lazy, useState } from 'react';
import PopupDialog from './third-party/dialog';
// import LogoutIcon from '@mui/icons-material/Logout';
// import { alpha } from '@mui/material/styles';
import LogoutConfirmDialog from './third-party/LogoutConfirmDialog';

// the forms load when their dialog first opens, not with every page
const ChangePinFromDashboard = lazy(() => import('./Header/ChangePasswordAndPin/ChangePinFromDashboard'));
const ChangePasswordFromDashboard = lazy(() => import('./Header/ChangePasswordAndPin/ChangePasswordFromDashboard'));

interface MenuProps {
  anchorEl: null | HTMLElement;
  handleClose: () => void;
}
function ProfileMenu({ handleClose, anchorEl }: MenuProps) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenPassword, setIsOpenPassword] = useState(false);
  const [isOpenLogout, setLogoutOpen] = useState(false);
  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleOpenPassword = () => {
    setIsOpenPassword(true);
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          onClick={() => {
            setLogoutOpen(true);
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            navigate(`/changePassword`);
          }}
        >
          <ListItemIcon>
            <LockOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Change Password
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            handleClose(); // Close the Menu
            handleOpenPassword(); // Open Change Password Popup
          }}
        >
          <ListItemIcon>
            <LockOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Reset Password
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose(); // Close the Menu
            handleOpen(); // Open Update Pin Popup
          }}
        >
          <ListItemIcon>
            <LockOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Reset PIN
        </MenuItem>
      </Menu>

      {/* Popup Dialog for PIN Rendered Outside */}
      <PopupDialog
        isOpen={isOpen}
        setOpen={setIsOpen}
        header={'Reset PIN'}
        releaseButtonLabel="Release"
        onReleaseClick={() => {}}
      >
        <Suspense fallback={null}>
          <ChangePinFromDashboard setIsOpen={setIsOpen} />
        </Suspense>
      </PopupDialog>
      {/* Popup Dialog for Password Rendered Outside */}
      <PopupDialog
        isOpen={isOpenPassword}
        setOpen={setIsOpenPassword}
        header={'Reset Password'}
        releaseButtonLabel="Release"
        onReleaseClick={() => {}}
      >
        <Suspense fallback={null}>
          <ChangePasswordFromDashboard setIsOpenPassword={setIsOpenPassword} />
        </Suspense>
      </PopupDialog>

      <LogoutConfirmDialog
        open={isOpenLogout}
        onClose={() => setLogoutOpen(false)}
        onConfirm={() => {
          clearLocalStorage();
          navigate(getLogoutPath());
        }}
      />
    </>
  );
}

export default ProfileMenu;
